import { NvLogin } from '@simwood/nv-react-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { restAPIBase } from '../../helpers/nvFetch';
import { isElectron } from '../../helpers/platform';
import * as platform from '../../helpers/platformApi';
import { externalLoginStarted, tokenReceived } from '../../reducers/user';
import { StoreDispatch, StoreState } from '../../store';
import * as styles from './styles.module.scss';

const Login: React.FC = () => {
  const dispatch = useDispatch<StoreDispatch>();
  const forgotPasswordLocation = useSelector(
    (state: StoreState) => state.branding.branding?.forgotPasswordLocation,
  );
  const signUpUrl = useSelector(
    (state: StoreState) => state.branding.branding?.signUpUrl,
  );
  const logoSrc = useSelector(
    (state: StoreState) => state.branding?.partnerLogoSrc,
  );
  const inverted = useSelector(
    (state: StoreState) => state.branding.branding?.topbarInverted,
  );
  const loginRedirectUrl = useSelector(
    (state: StoreState) => state.branding.branding?.loginRedirectUrl,
  );

  const handleSubmit = (accessToken: string, expires: string) => {
    dispatch(tokenReceived({ accessToken, expires }));
  };

  return (
    <NvLogin
      className={isElectron() ? styles.desktopLogin : undefined}
      apiBase={restAPIBase()}
      logoSrc={logoSrc}
      forgotPasswordLink={forgotPasswordLocation}
      signUpLink={signUpUrl}
      onToken={handleSubmit}
      inverted={inverted}
      loginRedirectUrl={loginRedirectUrl}
      dev={process.env.NODE_ENV === 'development'}
      partnerId={process.env.NODE_ENV === 'development' ? '1' : undefined}
      oauthPlatform={isElectron() ? 'DESKTOP' : 'WEB'}
      oauthRedirectUrlOverride={
        isElectron() ? 'https://verticall.io/auth/callback.html' : undefined
      }
      oauthNavigate={
        isElectron()
          ? (url) => {
              dispatch(externalLoginStarted());
              platform.openInExternalBrowser(url);
            }
          : undefined
      }
    />
  );
};

export default Login;
